var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card-actions',[_c('v-spacer'),_c('v-btn',{attrs:{"outlined":"","color":"primary","disabled":_vm.disabled},on:{"click":_vm.showConfirmRequest}},[_vm._v(" Fråga om annat datum ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }